export default __webpack_public_path__ + "static/media/user.82eb19f5.png";